// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.TextComponent {
  position: relative;
  border: 1px solid transparent;
  border-radius: 8px;
}
.TextComponent:has(:not(.hasFocus)) {
  height: var(--textHeight);
  overflow-y: scroll;
}
.TextComponent:has(:not(.hasFocus))::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.TextComponent:has(:not(.hasFocus))::-webkit-scrollbar-track {
  background: transparent;
}
.TextComponent:has(:not(.hasFocus))::-webkit-scrollbar-thumb {
  background: var(--color_neutral_200);
  height: 80px;
  border-radius: 50px;
}
.TextComponent:has(:not(.hasFocus)):hover::-webkit-scrollbar-thumb {
  background: var(--color_neutral_400);
}
.TextComponent:has(:not(.hasFocus))::-webkit-scrollbar-thumb:active {
  background: var(--color_neutral_500);
}
.TextComponent:has(.hasFocus) {
  border: 1px solid var(--color_neutral_500);
  overflow: visible;
}
.TextComponent:has(.hasFocus) .content-editable {
  height: calc(var(--textHeight) - 2px);
  overflow-y: scroll;
}
.TextComponent:has(.hasFocus) .content-editable::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.TextComponent:has(.hasFocus) .content-editable::-webkit-scrollbar-track {
  background: transparent;
}
.TextComponent:has(.hasFocus) .content-editable::-webkit-scrollbar-thumb {
  background: var(--color_neutral_200);
  height: 80px;
  border-radius: 50px;
}
.TextComponent:has(.hasFocus) .content-editable:hover::-webkit-scrollbar-thumb {
  background: var(--color_neutral_400);
}
.TextComponent:has(.hasFocus) .content-editable::-webkit-scrollbar-thumb:active {
  background: var(--color_neutral_500);
}
.TextComponent:hover {
  border: 1px solid var(--color_neutral_500);
}
.TextComponent .wall {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 2;
}

.TextComponent.isViewMode {
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/modules/dashboard/text-component/text-component.styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,kBAAA;EACA,6BAAA;EACA,kBAAA;AAeF;AAbE;EACE,yBAAA;EACA,kBAAA;AAeJ;ADVE;EACE,UAAA;EACA,WAAA;ACYJ;ADTE;EACE,uBAAA;ACWJ;ADRE;EACE,oCAdM;EAeN,YAAA;EACA,mBAAA;ACUJ;ADNI;EACE,oCApBS;AC4Bf;ADJE;EACE,oCAxBY;AC8BhB;AA7BE;EACE,0CAAA;EACA,iBAAA;AA+BJ;AA7BI;EACE,qCAAA;EACA,kBAAA;AA+BN;ADpCE;EACE,UAAA;EACA,WAAA;ACsCJ;ADnCE;EACE,uBAAA;ACqCJ;ADlCE;EACE,oCAdM;EAeN,YAAA;EACA,mBAAA;ACoCJ;ADhCI;EACE,oCApBS;ACsDf;AD9BE;EACE,oCAxBY;ACwDhB;AA3CE;EACE,0CAAA;AA6CJ;AA1CE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AA4CJ;;AAxCA;EACE,YAAA;AA2CF","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.TextComponent {\n  position: relative;\n  border: 1px solid transparent;\n  border-radius: 8px;\n\n  &:has(:not(.hasFocus)) {\n    height: var(--textHeight);\n    overflow-y: scroll;\n    @include scrollbar;\n  }\n\n  &:has(.hasFocus) {\n    border: 1px solid var(--color_neutral_500);\n    overflow: visible;\n\n    .content-editable {\n      height: calc(var(--textHeight) - 2px);\n      overflow-y: scroll;\n\n      @include scrollbar;\n    }\n  }\n\n  &:hover {\n    border: 1px solid var(--color_neutral_500);\n  }\n\n  .wall {\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    z-index: 2;\n  }\n}\n\n.TextComponent.isViewMode {\n  border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
